import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { stripDashes } from '@zelis/platform-ui-components';
import { MemberParams } from '@interfaces/member-params.model';
import { MemberContactPreferencesParams } from '../interfaces/member.preferences.params';
import { MemberAddressParams } from '../interfaces/member.address.params';
import { MemberPreferredContactMethods } from '@interfaces/member-preferred-contact-methods.model';
import { PreferredAddress } from '@interfaces/preferred-address.model';
import { forEach } from 'lodash';

@Injectable()
export class UserPreferencesService {
  public stripDashes = stripDashes;

  constructor(private http: HttpClient) {}

  public updatePreferences(
    prefs: MemberPreferredContactMethods,
    member: MemberParams
  ): Observable<any> {
    const body = new MemberContactPreferencesParams(prefs, member);
    return this.http.post('/api/preferences', body, {
      withCredentials: true,
    });
  }

  public updatePreferredAddress(
    data: PreferredAddress,
    member: MemberParams
  ): Observable<any> {
    const params = new MemberAddressParams(data);
    return this.http.post('/api/preferences', member, {
      params: this.setUpdateAddressParams(params),
      withCredentials: true,
    });
  }

  private setUpdateAddressParams(rawParams: MemberAddressParams): HttpParams {
    let params = new HttpParams();

    forEach(rawParams, (val, prop) => {
      if (val) {
        params = params.set(prop, val);
      }
    });
    return params;
  }
}
